import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { QueueService } from 'app/common/services/Queue.service';
import { SocialService } from 'app/common/services/Social.service';
import { SocketService } from 'app/common/services/Socket.service';
import { UserService } from 'app/common/services/User.service';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'primeng/primeng';
import { ArrayStatus, AvailableStatus } from './available.const';
import { BaseComponent } from '../../../components/base.component';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
import { SocketListener } from '../socket.listener';
import { BASE_URL } from '../../../pages/admin/icontact/icontact.route';
@Component({
  selector: 'user-profile',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.css'],
  providers: [UserService, BsModalService, SocialService, QueueService],
})
export class UserProfileComponent extends BaseComponent {
  public no_image = 'assets/images/contact.png';
  public isShowChannel = false;
  data: any;
  detail: any;
  items: any[] = [];
  limit = 10;
  size = 10;
  socket: any = null;
  public phone_out = '';

  collapsed = false;

  code = '';
  avaiable_status: any = 'AVAILABLE';
  public channelStatus: any = {
    chatStatus: 'AVAILABLE',
    emailStatus: 'AVAILABLE',
    facebookStatus: 'AVAILABLE',
    zaloStatus: 'AVAILABLE',
  };
  public noCalling: any = true;
  public is_show_setting = false;
  public is_show_detail = false;
  public isVoiceActivated = false;
  public image_contact = 'assets/images/contact.png';
  public checkRegisterRtc = false;

  public fb_unread = 0;
  public chat_unread = 0;
  messages: Message[] = [];
  public sippass: any = 'azA2023xZBc';
  public call_id: any;
  public call_type: any;
  public auto_answer = 0;
  public isOpens: any = { status: false, data: {} };

  @ViewChild('confirm_invite') confirmInvite: ElementRef;
  @ViewChild('confirm_forward') confirmForward: ElementRef;

  @ViewChild('dropdownv2') dropdown: ElementRef;
  @Output('newTab') newTab = new EventEmitter();

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private router: Router,
    private socketService: SocketService,
    private userService: UserService,
    private socketListener: SocketListener
  ) {
    super(changeDetector, toastr, modalService);
    this.socketListener.onStatusReceived.subscribe(res => {
      const { code, msg } = res;
      switch (code) {
        case environment.code.LOGIN_RESPOND_ID:
          this.handleLoginStatus(msg);
          break;
        case environment.code.CHANGE_AGENT_STATUS_RESPOND_ID:
          this.handleAgentStatusChange(msg);
          break;
      }
    });
    this.socketListener.onReLogin.subscribe(res => {
      this.logoutAndReLogin(res);
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.dropdown && this.dropdown.nativeElement) {
      if (!this.dropdown.nativeElement.contains(event.target)) {
        this.isOpens.status = false;
        this.isOpens.data = {};
      }
    }
  }

  toggleDropdown(data) {
    if (data._id == this.isOpens.data._id) {
      this.isOpens.status = !this.isOpens.status;
    } else {
      this.isOpens.status = true;
      this.isOpens.data = data;
    }
  }
  ngOnInit() {
    const status = localStorage.getItem('status');
    this.avaiable_status = status ? status : 'NOT AVAILABLE';
    if (!ArrayStatus.includes(this.avaiable_status)) {
      this.avaiable_status = AvailableStatus.NOT_AVAILABLE;
    }
  }

  handleLoginStatus(msg) {
    if (msg.data.status == 'OK') {
      this.avaiable_status = msg.data.userStatus;
      this.auto_answer = msg.data.autoAnswer;
    } else {
      // this.changeAvaiable('NOT AVAILABLE');
      console.log('login error code ' + msg.data.status);
      this.logout();
    }
  }

  handleAgentStatusChange(msg) {
    if (msg.data.errorcode == 0) {
      if (this.user.agent_id == msg.data.agentId) {
        if ('LOGOUT' == msg.data.status) {
          // logout now
          this.logout();
          return;
        }
        this.avaiable_status = msg.data.status;
        this.channelStatus = {
          chatStatus: msg.data.chatStatus,
          emailStatus: msg.data.emailStatus,
          facebookStatus: msg.data.facebookStatus,
          zaloStatus: msg.data.zaloStatus,
        };
        this.responseChangeAvaiable(this.avaiable_status);
      }
      this.socketService.execMsg(this.user.email, msg.objectId, msg.data, this.isVoiceActivated);
    } else {
      this.avaiable_status = this.user.avaiable_status;
      this.throwError('Thay đổi trạng thái thất bại!');
    }
  }

  sendMessage(event) {
    // hàm gửi event cho server
    const appMessage = { objectId: event.objectId, data: event };
    this.socket.emit('message', appMessage);
  }

  unRegisterRTC() {
    this.checkRegisterRtc = false;
    (window as any).unregister();
  }

  changeAvaiable(status) {
    this.avaiable_status = status.toString();
    this.socketService.changeAgentStatus({ status: status });
  }

  changeChannelStatus(channel) {
    const status = this.channelStatus[channel] == 'AVAILABLE' ? 'NOT AVAILABLE' : 'AVAILABLE';
    this.channelStatus[channel] = status;
    const data = {};
    data[channel] = status;
    this.socketService.changeAgentStatus(data);
  }

  responseChangeAvaiable(status) {
    this.userService.update(this.user._id, { avaiable_status: status }).subscribe(rs => {
      if (rs.status == 200) {
        localStorage.setItem('User', JSON.stringify(rs.data));
        localStorage.setItem('status', status.toString());
        this.avaiable_status = status.toString();
      }
    });
  }

  login() {
    if (!this.socket || !this.user.agent_id) {
      Sentry.captureMessage(
        `Tenant: ${this.user.tenant_id}|User: ${this.user._id}| Mất kết nối đến server!(wss disconnect now)`,
        Severity.Error
      );
      this.throwError('Mất kết nối đến server. Vui lòng thử lại sau!');
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGIN_REQUEST_ID,
      data: {
        objectId: environment.code.LOGIN_REQUEST_ID,
        avatar: this.user.avatar,
        username: this.user.email,
        name: this.user.name,
        agentId: this.user.agent_id,
        userType: this.user.role,
        token: localStorage.getItem('Access-Token'),
        tenantId: this.user.tenant_id || this.user._id,
        groupId: this.user.group_id,
        shiftId: 1,
      },
    });
  }

  profile() {
    this.socketService.opentab(this.user, 'user', 'edit');
  }

  logout() {
    console.log('Try to logout!!!');
    this.unRegisterRTC();
    try {
      this.socketService.logout();
    } catch (e) {
      console.log('error logout', e);
    }
    console.log('Logged out!!!');
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  logoutAndReLogin(data) {
    this.setLoading(true);
    console.log('Try to logout!!!');
    // this.unRegisterRTC();
    // try {
    //   this.socketService.logout();
    // } catch (e) {
    //   console.log('error logout', e);
    // }
    console.log('Logged out!!!');
    // save
    localStorage.setItem('Access-Token', data.token);
    localStorage.setItem('FireBase-Token', data.token_firebase);
    localStorage.setItem('Token-Expire', data.ttl);
    const expiresAt = JSON.stringify(data.ttl * 1000 + Date.now());
    localStorage.setItem('expires_at', expiresAt);
    localStorage.setItem('status', '1');
    localStorage.setItem('Spying', '1');
    if (data.info && data.user_id) {
      data.info.user_id_evs = data.user_id;
      data.info.tenant_id = data.info.tenant_id ? data.info.tenant_id : data.tenant_id;
      localStorage.setItem('User', JSON.stringify(data.info));
    }
    setTimeout(async () => {
      this.setLoading(false);
      await this.router.navigate([BASE_URL]);
      window.location.reload();
    }, 1000);
  }

  logoutOthers() {
    this.unRegisterRTC();
    console.log('Try to logout others!!!');
    console.log('Logged out others!!!');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/user-status/user-status.component.ts